if (!customElements.get('card-color-swatches')) {
  class CardColorSwatches extends HTMLElement {
    connectedCallback() {
      this.card = this.closest('.card-wrapper');
      if (!this.card) return;

      this.image = this.card.querySelector('.js-card-product-media');
      this.links = this.card.querySelectorAll('a.full-unstyled-link');
      this.buttons = this.querySelectorAll('[data-card-color]');

      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => this.onSelect(event));
      });
    }

    onSelect(event) {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;

      this.buttons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      if (this.image && button.dataset.src) {
        this.image.src = button.dataset.src;
        if (button.dataset.srcset) {
          this.image.srcset = button.dataset.srcset.trim();
        }
      }

      if (button.dataset.variantUrl) {
        this.links.forEach((link) => {
          link.href = button.dataset.variantUrl;
        });
      }
    }
  }

  customElements.define('card-color-swatches', CardColorSwatches);
}
